import { render, staticRenderFns } from "./tourschool.vue?vue&type=template&id=72199610&scoped=true"
import script from "./tourschool.vue?vue&type=script&lang=js"
export * from "./tourschool.vue?vue&type=script&lang=js"
import style0 from "./tourschool.vue?vue&type=style&index=0&id=72199610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72199610",
  null
  
)

export default component.exports